import { defaultLang } from '@/app/routes';
import { useT } from '@/i18n/LocaleProvider';

import { SiteMapCanvas } from './SiteMapCanvas';
import { useWikiGraph } from './useWikiGraph';

type MapViewProps = {
  lang?: string;
  onNavigate?: (slug: string) => void;
};

export function MapView({ lang = defaultLang, onNavigate }: MapViewProps) {
  const t = useT();
  const { data, isLoading, error } = useWikiGraph();

  return (
    <div className="map-view" data-testid="map-view">
      <h1 className="map-view-title">{t('map_title')}</h1>
      {isLoading ? <div className="empty-note">{t('map_loading')}</div> : null}
      {!isLoading && error ? <div className="empty-note">{error}</div> : null}
      {!isLoading && !error && data ? (
        <div className="map-view-canvas-wrap">
          <SiteMapCanvas graph={data} lang={lang} onNavigate={onNavigate} />
        </div>
      ) : null}
    </div>
  );
}
